const delete_dialog = {
	confirmation:
		"Zur Bestätigung bitten wir Sie, den Namen Ihres VPS <strong>{{name}}</strong> in das folgende Eingabefeld einzugeben.",
	running: {
		description:
			"Ein VPS kann nicht gelöscht werden, solange sein Status noch aktiv ist. Beenden Sie den VPS, bevor er gelöscht werden kann.",
		title: "Ihr VPS ist noch aktiv!",
	},
	title: "VPS löschen",
	warning: "Das Löschen eines VPS ist dauerhaft und kann nicht rückgängig gemacht werden.",
};

export default delete_dialog;
